function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
      link.addEventListener('click', function(event) {
          Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
          this.classList.add('active');
          if(this.classList.contains('listv')){
              document.getElementById('product-grid').classList.add('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-twogrid');
          }else if(this.classList.contains('gridv')){  
              document.getElementById('product-grid').classList.add('product-grid');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-twogrid');
          }else if(this.classList.contains('galleryv')){
              document.getElementById('product-grid').classList.add('product-gallery');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
              document.getElementById('product-grid').classList.remove('product-twogrid');
          }else if(this.classList.contains('twogrid')){
              document.getElementById('product-grid').classList.add('product-twogrid');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
          }
      });
  });
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// TIMER

setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.timer_wrap');
  countCardSections.forEach((countdownSection) => {
  var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
  var now = new Date().getTime();
  var distance = countDownDate - now;
  if (distance < 0 || isNaN(countDownDate)) {
    countdownSection.querySelector('.timer_days').textContent = "00";
    countdownSection.querySelector('.timer_hours').textContent = "00";
    countdownSection.querySelector('.timer_minutes').textContent = "00";
    countdownSection.querySelector('.timer_seconds').textContent = "00";
  } else {
    countdownSection.querySelector('.timer_days').textContent = addLeadingZero(Math.floor(distance / (1000 * 60 * 60 * 24)));
    countdownSection.querySelector('.timer_hours').textContent = addLeadingZero(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    countdownSection.querySelector('.timer_minutes').textContent = addLeadingZero(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
    countdownSection.querySelector('.timer_seconds').textContent = addLeadingZero(Math.floor((distance % (1000 * 60)) / 1000));
  }
  });
}
function addLeadingZero(number) {
  return number < 10 ? "0" + number : number;
}